// ==================== src/api/system/giftPointsConfig.ts ====================
// 对应后端：system.points.controller.GiftPointsConfigController
// 请求前缀：/api/points/config/gift
//
// 注意：请求与响应的 giftPoints 结构不对称
//   - 响应 giftPoints：数组（后端已 join giftName 返回）
//   - 请求 giftPoints：Record（后端实体 Map<Integer,Long>）
// 严格照抄后端 DTO 定义，不要"顺手统一"。
import { post } from '@/utils/HttpUtils';

/** 响应结构：GiftPointsConfigResponse */
export interface GiftBonusItem {
  giftId: number;
  giftName: string;
  points: number;
}

export interface GiftPointsConfigResponse {
  ifBot: boolean;
  ifPricePoint: boolean;
  pricePoint: number;
  ifGiftPoint: boolean;
  giftPoints: GiftBonusItem[];
}

/** 请求结构：GiftPointsConfigUpdateRequest */
export interface GiftPointsConfigUpdateRequest {
  ifBot: boolean;
  ifPricePoint: boolean;
  /** @NotNull + @Min(1)，不可传 null */
  pricePoint: number;
  ifGiftPoint: boolean;
  /** Map<Integer, Long>，key 为 giftId */
  giftPoints: Record<number, number>;
}

export const systemGiftPointsConfigApi = {
  /** 查询礼物积分配置（含 giftName） */
  get: () =>
    post<GiftPointsConfigResponse>('/api/points/config/gift/get'),

  /** 更新礼物积分配置 */
  update: (data: GiftPointsConfigUpdateRequest) =>
    post<GiftPointsConfigResponse>('/api/points/config/gift/update', data),
};